<template>
  <div v-if="config?.title">
    <BaseNotification
      type="warning"
      layout="inline"
      class="mb-6 leading-5"
    >
      <div class="font-semibold mb-5 mt-px">
        {{ config.title }}
      </div>
      <div>{{ config.message }}</div>
    </BaseNotification>

    <BaseButton
      color="red"
      size="large"
      class="w-full mb-4 flex items-center justify-center"
      data-test-id="enq-form-find-similar-venue"
      @click="findSimilarVenues"
    >
      Find similar venues

      <TagIcon
        :icon="OpenNewTabIcon"
        color="mono-white"
        class="ml-2"
      />
    </BaseButton>

    <BaseButton
      v-if="config.enquireAnywayButton"
      color="white"
      size="large"
      class="w-full flex items-center justify-center"
      @click="enquireAnyway"
    >
      Enquire anyway
    </BaseButton>
  </div>
</template>

<script>
import OpenNewTabIcon from '@tagvenue/icons/24/bold/general/link-external-01.svg';
import { markRaw } from 'vue';

import TagIcon from '@/components/TagIcon.vue';
import BaseNotification from '@/components/Ui/BaseNotification.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'SuspensionWarning',
  components: {
    TagIcon,
    BaseButton,
    BaseNotification,
  },
  data() {
    return {
      OpenNewTabIcon: markRaw(OpenNewTabIcon),
      views: [
        {
          title: 'This venue has not responded to several recent enquiries.',
          message: 'We are working on improving their response time. In the meantime, we recommend you to contact other similar venues instead.',
          enquireAnywayButton: true,
        },
        {
          title: 'This venue is no longer available on Tagvenue.',
          message: 'Unfortunately, this space is no longer a\u00A0part of the Tagvenue network. We recommend you to contact other similar venues instead.',
          enquireAnywayButton: false,
        },
        {
          title: 'This venue is currently unavailable for new enquiries.',
          message: 'We’re working closely with the venue team to resolve a temporary issue. In the meantime, we recommend reaching out to other similar venues.',
          enquireAnywayButton: true,
        },
        {
          title: 'This venue’s listing is currently paused.',
          message: 'We’re working on bringing it back online as soon as possible. In the meantime, we recommend reaching out to other similar venues.',
          enquireAnywayButton: true,
        },
        {
          title: 'This venue is temporarily closed.',
          message: 'The venue is currently not operating and will be unavailable for an extended period. In the meantime, we recommend exploring other similar venues to continue with your planning.',
          enquireAnywayButton: true,
        },
      ],
      config: {},
    };
  },
  methods: {
    track(action) {
      App.track.all({
        category: 'enquiry-form-venue-suspended',
        action,
        label: this.$store.state.room.id,
      });
    },
    findSimilarVenues() {
      this.track('find-similar-venues-clicked');

      this.$store.dispatch('trackFindSimilarVenues');

      if (window.location.href.includes('E2E_STOP_REDIRECTION')) {
        return;
      }

      window.open(this.$store.getters.searchSimilarEventsUrl);
    },
    enquireAnyway() {
      this.track('enquire-anyway-clicked');
      this.$store.commit('hideSuspensionWarning');
    },
  },
  mounted() {
    this.track('warning-displayed');

    const index = this.$store.state.suspensionProblemsMap.findIndex(view => {
      return this.$store.state.suspensionProblemIds.find(id => view.includes(id));
    });
    if (index === -1 || !this.views[index]) {
      console.error('SuspensionWarning.vue: No view found for the given problem ids', {
        suspensionProblemsMap: this.$store.state.suspensionProblemsMap,
        suspensionProblemIds: this.$store.state.suspensionProblemIds,
      });
      return;
    }
    this.config = this.views[index];
  },
};
</script>

<style lang="scss" scoped>

</style>
